export default __webpack_public_path__ + "static/media/project-4.3.53989e62.png";